export default {
  classes:
    'px-2 py-1 text-xs bg-success text-green-800 uppercase font-normal text-center',
  variants: {
    success:
      'px-2 py-1 text-xs bg-success text-green-800 uppercase font-normal text-center',

    info:
      'px-2 py-1 text-xs bg-info text-blue-800 uppercase text-center font-normal',

    danger:
      'px-2 py-1 text-xs bg-danger text-red-700 uppercase font-normal text-center',

    warning:
      'px-2 py-1 text-xs bg-warning text-indigo-900 uppercase font-normal text-center',
  },
}
